// Three logins share one origin: superadmin, admin (ops) and cars. localStorage
// is shared across every tab of that origin, so the tabs can disagree about
// who is signed in — the classic multi-tab bug this module exists to end.
//
// The rule that keeps them apart: a tab BELONGS to the realm that owns its
// URL. An auth failure may only ever redirect a tab that belongs to the
// failing realm — an expenses 401 firing in a superadmin tab must clear the
// expenses tokens, not yank the superadmin off their screen.

import { STORAGE_KEYS } from '../constants/app.constants';

export const REALMS = {
  superadmin: {
    loginTab: 'admin',
    tokenKeys: [STORAGE_KEYS.ACCESS_TOKEN, STORAGE_KEYS.REFRESH_TOKEN, STORAGE_KEYS.USER_INFO],
  },
  ops: {
    loginTab: 'expenses',
    tokenKeys: [STORAGE_KEYS.EXPENSES_ACCESS_TOKEN, STORAGE_KEYS.EXPENSES_REFRESH_TOKEN],
  },
  cars: {
    loginTab: 'cars',
    tokenKeys: [STORAGE_KEYS.CARS_ACCESS_TOKEN, STORAGE_KEYS.CARS_REFRESH_TOKEN, STORAGE_KEYS.CARS_STAFF],
  },
};

/**
 * Which realm owns this pathname.
 *   /ops/* and /expenses   → 'ops'   (the admin/operations workspace)
 *   /lot*                  → 'cars'  (the cars team workspace)
 *   /login, /supervisor/*  → null    (nobody's — never hijack a login page)
 *   everything else        → 'superadmin'
 */
export const realmForPath = (pathname) => {
  const p = pathname || '';
  if (p === '/login' || p.startsWith('/login/') || p.startsWith('/supervisor')) return null;
  if (p === '/ops' || p.startsWith('/ops/') || p === '/expenses' || p.startsWith('/expenses/')) {
    return 'ops';
  }
  if (p === '/lot' || p.startsWith('/lot/')) return 'cars';
  return 'superadmin';
};

/** May an auth failure in `realm` redirect a tab currently showing `pathname`? */
export const canHijackPath = (realm, pathname) => realmForPath(pathname) === realm;
